import { Post } from '@/@types/post'
import { css } from '@emotion/react'
import { modals } from '@mantine/modals'
import PostCard from '../Post/PostCard'
import Comment from './Comment'
import CommentForm from './CommentForm'
import type { ReplyToComment } from './types'

export interface CommentFormModalProps {
	onSubmit?: () => void
	replyToComment?: ReplyToComment | null
	replyToPost?: Post | null
}

export function showCommentFormModal(
	options?: CommentFormModalProps & Parameters<typeof modals.open>[0]
) {
	const { onSubmit, replyToComment, replyToPost: post, onClose, ...rest } = options ?? {}
	const comment = replyToComment?.to

	const targetId = post?.id ?? comment?.targetId
	const targetType = post?.type ?? comment?.targetType

	return modals.open({
		title: '回复',
		children: (
			<div
				css={css`
					display: flex;
					flex-direction: column;
					gap: 20px;
					color: var(--tint-primary);
				`}
			>
				{post && (
					<PostCard
						data={post}
						css={css`
							padding: unset;
						`}
					/>
				)}

				{comment && (
					<Comment
						data={{
							id: comment.id,
							targetType: comment.targetType,
						}}
						noActions
						showThreadLine
						noSuffixTitle
					/>
				)}

				{targetId && targetType && (
					<CommentForm
						autoFocus
						targetId={targetId}
						targetType={targetType}
						replyToComment={replyToComment}
						onSubmit={async () => {
							onClose?.()
							onSubmit?.()
						}}
					/>
				)}
			</div>
		),
		onClose,
		...rest,
	})
}
